<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="vertical">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24" v-if="!deviceId">
              <a-form-item label="所属管线" prop="pipelineId">
                <a-select
                  v-model="queryParam.pipelineId"
                  placeholder="请选择所属管线"
                  allow-clear
                  @change="pipelineIdChange"
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="item in pipelineList" :key="item.id" :value="item.id">
                    {{ item.pipelineName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="!deviceId">
              <a-form-item label="位置编号" prop="deviceId">
                <a-select
                  v-model="queryParam.deviceId"
                  placeholder="请选择位置编号"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="item in deviceList" :key="item.id" :value="item.id" :title="item.locationDescription+'-'+ item.deviceCode">
                    {{ item.locationDescription }}-{{ item.deviceCode }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="位置描述"
                prop="gpsAddress"
              >
                <a-input
                  v-model="queryParam.gpsAddress"
                  placeholder="请输入位置描述"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="在线状态" prop="onlineStatus">
                <a-select v-model="queryParam.onlineStatus" placeholder="请选择在线状态" allow-clear>
                  <a-select-option :key="0" :value="0">离线</a-select-option>
                  <a-select-option :key="1" :value="1">在线</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="设备状态" prop="deviceStatus">
                <a-select v-model="queryParam.deviceStatus" placeholder="请选择设备状态" allow-clear>
                  <a-select-option :key="0" :value="0">正常</a-select-option>
                  <a-select-option :key="1" :value="1">故障</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="保护状态" prop="protectionStatus">
                <a-select v-model="queryParam.protectionStatus" placeholder="请选择保护状态" allow-clear>
                  <a-select-option :key="0" :value="0">正常保护</a-select-option>
                  <a-select-option :key="1" :value="1">欠保护</a-select-option>
                  <a-select-option :key="2" :value="2">过保护</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="选择时间" prop="customUserId">
                <a-range-picker show-time v-model="value" style="width: 100%" @change="handleChange"> </a-range-picker>
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button-->
<!--          type="primary"-->
<!--          :disabled='this.addressDisabled'-->
<!--          @click="addressClick">-->
<!--          <a-icon type="diff" />编辑-->
<!--        </a-button>-->
        <a-button type="primary" @click="handleExport" v-hasPermi="['saifuneng:devicedata:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          :isLoca="true"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
          @select="handleSelect"
        />
      </div>
      <!-- 转移修改 -->
      <address-edit-form
        ref="addressEditForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 4350, y: 3000 }"
      >
<!--    :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"    -->
        <span slot="index" slot-scope="text, record, index">
          {{ (queryParam.pageNum - 1) * queryParam.pageSize + (index + 1) }}
        </span>
        <span slot="protectionStatus" slot-scope="text, record">
          <a-tag v-if="record.protectionStatus == 0" color="#87d068">正常</a-tag>
          <a-tag v-if="record.protectionStatus == 1" color="red">欠保护</a-tag>
          <a-tag v-if="record.protectionStatus == 2" color="red">过保护</a-tag>
        </span>
        <span slot="deviceStatus" slot-scope="text, record">
          <a-tag v-if="record.deviceStatus == 0" color="#87d068">正常</a-tag>
          <a-tag v-if="record.deviceStatus == 1" color="#f50">故障</a-tag>
        </span>
        <span slot="onlineStatus" slot-scope="text, record">
          <a-tag v-if="record.onlineStatus == 1" color="#87d068">在线</a-tag>
          <a-tag v-if="record.onlineStatus == 0" color="#A9A9A9">离线</a-tag>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span
          slot="lonAndLat"
          slot-scope="text, record"
        >
          <a @click="openAmapNavigation(record)" v-if="record.lonAndLat" :title="record.gpsLocation">
            {{ record.gpsLocation }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageDeviceDataTdengine,
  listPipeline,
  listDevice
} from '@/api/saifuneng/devicedata'
import AddressEditForm from './modules/AddressEditForm.vue'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'DeviceData',
  components: {
    AddressEditForm
  },
  props: ['deviceId'],
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pipelineList: [],
      deviceList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      addressDisabled: true,
      ids: [],
      loading: false,
      total: 0,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParam: {
        deviceCategorizeCode: 'recorder',
        pipelineId: undefined,
        deviceId: undefined,
        gpsAddress: undefined,
        onlineStatus: undefined,
        deviceStatus: undefined,
        protectionStatus: undefined,
        ids: undefined,
        pageNum: 1,
        pageSize: 10
      },
      value: [],
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          ellipsis: true,
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '位置编号',
          dataIndex: 'address',
          ellipsis: true,
          align: 'center',
          width: 250,
          fixed: 'left'
        },
        {
          title: '位置描述',
          dataIndex: 'locationDescription',
          ellipsis: true,
          align: 'center',
          width: 250,
          fixed: 'left'
        },
        // {
        //   title: '阴保状态',
        //   dataIndex: 'protectionStatus',
        //   ellipsis: true,
        //   align: 'center',
        //   scopedSlots: { customRender: 'protectionStatus' }
        // },
        // {
        //   title: '设备状态',
        //   dataIndex: 'deviceStatus',
        //   ellipsis: true,
        //   align: 'center',
        //   scopedSlots: { customRender: 'deviceStatus' }
        // },
        {
          title: '在线状态',
          dataIndex: 'onlineStatus',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'onlineStatus' }
        },
        {
          title: '断电电位（V）',
          dataIndex: 'voff',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '通电电位（V）',
          dataIndex: 'electrifiedPotential',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '交流电流密度（A/m²）',
          dataIndex: 'acCurrentFlowingThroughTheTestPieceDensity',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '直流电流密度（mAcm²）',
          dataIndex: 'directCurrentFlowingThroughTheTestPieceDensity',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '自腐蚀电位（V）',
          dataIndex: 'selfCorrosionPotential',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '牺牲阳极（mA）',
          dataIndex: 'sacrificialAnode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '交流干扰电压（v/vrms）',
          dataIndex: 'acInterferenceVoltage',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '流经试片交流电流（mA）',
          dataIndex: 'acCurrentFlowingThroughTheTestPiece',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '流经试片直流电流（mA）',
          dataIndex: 'directCurrentFlowingThroughTheTestPiece',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '牺牲阳极（V）',
          dataIndex: 'sacrificialAnodeVoltage',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '剩余电量（%）',
          dataIndex: 'batteryLevel',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '所属管线',
          dataIndex: 'pipelineName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '管线里程',
          dataIndex: 'mileageRange',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '信号强度',
          dataIndex: 'signalStrength',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '采集时间',
          dataIndex: 'deviceTime',
          scopedSlots: { customRender: 'deviceTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '接收时间',
          dataIndex: 'systemTime',
          scopedSlots: { customRender: 'systemTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '电池电压（V）',
          dataIndex: 'batteryVoltage',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '设备编号',
          dataIndex: 'deviceCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '设备名称',
          dataIndex: 'deviceName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '定位位置',
          dataIndex: 'lonAndLat',
          scopedSlots: { customRender: 'lonAndLat' },
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  async created() {
    // 初始化表格
    this.queryParam.deviceId = this.deviceId
    if (this.$route.query.protectionStatus) {
      this.queryParam.protectionStatus = this.$route.query.protectionStatus
      this.advanced = true
    }
    if (this.$route.query.deviceId) {
      this.queryParam.deviceId = this.$route.query.deviceId
    }
    this.getList()
    this.getPipelineList()
    this.getDeviceList(null)
  },
  computed: {},
  watch: {},
  methods: {
    handleSelect(e) {
      console.log('e', e)

      const arr = e
        .filter((item) => item.width === 0)
        .map((item) => {
          return {
            title: item.title,
            dataIndex: item.dataIndex,
            ellipsis: item.ellipsis,
            align: item.align,
            ellipsis2: item.ellipsis2,
            width: item.width,
            width2: item.width2
          }
        })
      localStorage.setItem('deviceData', JSON.stringify(arr))
    },
    /** 查询设备信息列表 */
    getList() {
      this.loading = true
      if (this.dateRange !== null && this.dateRange !== '' && this.dateRange.length === 2) {
        this.queryParam.createBeginTime = this.dateRange[0]
        this.queryParam.createEndTime = this.dateRange[1]
      }
      pageDeviceDataTdengine(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleChange(e) {
      if (e != null && e.length == 2) {
        this.queryParam.createBeginTime = e[0].format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.createEndTime = e[1].format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.queryParam.createBeginTime = null
        this.queryParam.createEndTime = null
      }
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      // 日期范围
      this.dateRange = []
      this.queryParam = {
        deviceCategorizeCode: 'recorder',
        pipelineId: undefined,
        deviceId: undefined,
        gpsAddress: undefined,
        onlineStatus: undefined,
        deviceStatus: undefined,
        protectionStatus: undefined,
        ids: '',
        pageNum: 1,
        pageSize: 10
      }
      this.queryParam.deviceId = this.deviceId
      this.value = []
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.selectedRowKeys = []
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.selectedRowKeys = []
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
      this.addressDisabled = this.ids.length > 0 ? false : true

      this.queryParam.ids = this.ids.join(',')
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    getPipelineList() {
      listPipeline().then((response) => {
        this.pipelineList = response.data
      })
    },
    pipelineIdChange(value) {
      this.getDeviceList(value)
      this.queryParam.deviceId = null
    },
    getDeviceList(pipelineId) {
      listDevice({ pipelineId: pipelineId, deviceCategorizeCode: 'recorder' }).then((response) => {
        this.deviceList = response.data
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      if (!that.queryParam.deviceId) {
        this.$message.warning('请先选择位置编号', 3)
        return false
      } else {
        this.$confirm({
          title: '是否确认导出?',
          content: '此操作将导出当前条件下所有数据',
          onOk() {
            that.download(
              'saifuneng/saifuneng-device-data/tdengine/export',
              {
                ...that.queryParam
              },
              `data_${new Date().getTime()}.xlsx`
            )
          },
          onCancel() {}
        })
      }
    },
    /** 打开高德导航 */
    openAmapNavigation(record) {
      var fromLongitude = ''
      var fromLatitude = ''
      var fromPlaceName = ''
      this.getCurrentLocation().then(res => {
        fromLongitude = res.longitude
        fromLatitude = res.latitude
        const logAndLatArr = record.lonAndLat.split(',')
        var toLongitude = logAndLatArr[0]
        var toLatitude = logAndLatArr[1]
        var toPlaceName = record.gpsLocation
        console.log('起点：' + fromLongitude + ',' + fromLatitude)
        console.log('终点：' + toLongitude + ',' + toLatitude)
        const url = `https://uri.amap.com/navigation?from=${fromLongitude},${fromLatitude},${encodeURIComponent(fromPlaceName)}&to=${toLongitude},${toLatitude},${encodeURIComponent(toPlaceName)}&mode=car&policy=0&callnative=1`
        window.open(url, '_blank')
      }).catch(err => {
        this.$message.warning(err)
      })
    },
    getCurrentLocation() {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(new Error('浏览器不支持定位功能'))
          return
        }
        navigator.geolocation.getCurrentPosition(
          // 成功回调
          (position) => {
            const location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              accuracy: position.coords.accuracy,
              altitude: position.coords.altitude,
              altitudeAccuracy: position.coords.altitudeAccuracy,
              heading: position.coords.heading,
              speed: position.coords.speed,
              timestamp: position.timestamp
            }
            resolve(location)
          },
          // 失败回调
          (error) => {
            let errorMessage = ''
            switch (error.code) {
              case error.PERMISSION_DENIED:
                errorMessage = '用户拒绝定位请求'
                break
              case error.POSITION_UNAVAILABLE:
                errorMessage = '位置信息不可用'
                break
              case error.TIMEOUT:
                errorMessage = '定位请求超时'
                break
              case error.UNKNOWN_ERROR:
                errorMessage = '未知错误'
                break
            }
            reject(errorMessage)
          },
          // 可选配置
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
          }
        )
      })
    }


  }
}
</script>
